import { useState } from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import SiteMapping from '@configs/siteMapping';
import { useTranslation } from 'next-i18next';
import LiveScoreToday from './LiveScoreToday';
import LiveScoreResult from './LiveScoreResult';

const LiveScoreOption = ({ isOnTodayTab, setIsOnTodayTab }) => {
    const { t } = useTranslation();
    return (
        <div className="live-score__option">
            <div className="switch-bar">
                <a className="btn" onClick={() => setIsOnTodayTab(true)} data-selected={isOnTodayTab}>
                    <span className="text">{t('lbl_today')}</span>
                </a>
                <a className="btn" onClick={() => setIsOnTodayTab(false)} data-selected={!isOnTodayTab}>
                    <span className="text">{t('lbl_Result')}</span>
                </a>
            </div>
        </div>
    );
};

const LiveScore = () => {
    const { siteName, loginWebEnableLiveScore } = useSiteInfo();
    const [isOnTodayTab, setIsOnTodayTab] = useState(true);

    if (!loginWebEnableLiveScore) {
        return null;
    }

    return (
        <div className="live-score" data-open="true">
            {
                {
                    [SiteMapping.viva88]: (
                        <LiveScoreOption isOnTodayTab={isOnTodayTab} setIsOnTodayTab={setIsOnTodayTab} />
                    ),
                    [SiteMapping.bong88]: (
                        <LiveScoreOption isOnTodayTab={isOnTodayTab} setIsOnTodayTab={setIsOnTodayTab} />
                    ),
                }[siteName]
            }
            {isOnTodayTab ? (
                <LiveScoreToday />
            ) : (
                <LiveScoreResult />
            )}
        </div>
    );
};

export default LiveScore;
